/* eslint-disable react/function-component-definition */
import React from 'react';
import { useParams } from 'react-router-dom';
import TabsSoluciones from '../components/soluciones/TabsSoluciones';

function Soluciones() {
  // lee “tab” de la URL
  const { tab } = useParams();
  // fallback al primer tab
  const defaultKey = (tab || 'bn100').toLowerCase();

  return (
    <div>
      {/* Hero */}
      <section className="w-full group h-32 md:h-56 p-6 flex justify-center items-end bg-gray-900 relative overflow-hidden">
        <h1 className="z-10 text-xl sm:text-2xl md:text-4xl lg:text-5xl font-extrabold text-white group-hover:-translate-y-3 transition duration-500">
          SOLUCIONES
        </h1>
        <img
          src="https://img-cdn.hytera.com/iwov-resources/hytera/02_products/11_landing_page/en_subpage_banner_DMR_Radios.jpg_n.webp"
          alt="Banner Andes-TEC"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-purple-950 opacity-70" />
      </section>

      <div className="my-8 mx-auto container">
        <div className="mb-8">
          <div className="rounded-2xl border-l-4 border-blue-500 bg-blue-50 p-6">
            <h2 className="text-blue-800 text-lg md:text-xl font-bold mb-2">
              Soluciones de Comunicación Avanzada
            </h2>
            <p className="text-sm md:text-base text-blue-900">
              Explora nuestras soluciones diseñadas para mejorar la eficiencia
              operativa y garantizar comunicaciones seguras y confiables…
            </p>
          </div>
        </div>

        {/* Pasa la clave a Tabs */}
        <TabsSoluciones defaultKey={defaultKey} />
      </div>
    </div>
  );
}

export default Soluciones;
